import 'font-awesome/css/font-awesome.css';
import React from 'react';
import CigHeader from './CigHeader';

function TenantSpinner({name, message, id, title}) {
    return (
        <div id={id} className='tw-font-normal tw-not-italic tw-flex tw-flex-col tw-h-screen tw-font-title'>
            <CigHeader showLogout={false} title={title}/>
            <div className='tw-pt-200px tw-w-1/2 tw-h-500px tw-mt-0 tw-mr-auto tw-mb-0 tw-ml-auto'>
                {
                    <div>
                        <div id="spinner" className='tw-float-left tw-pt-12px'>
                            <i className='fa fa-spinner fa-spin' style={{fontSize: '80px'}}></i>
                        </div>
                        <div id="spinner-msg-container" className='tw-table tw-pl-20px' style={{float: 'center'}}>
                            <span id="welcome-msg" className='tw-table-row tw-font-bold tw-leading-loose tw-text-1xl'>Welcome, {name}</span>
                            <span id="spinner-msg" className='tw-font-medium tw-text-16px'>{message}</span>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

TenantSpinner.displayName = 'TenantSpinner';
export default TenantSpinner;
